import { apiPost, apiGet, apiDelete } from "./client";

export function cancelArbs(membershipId) {
  return apiDelete("/utility/cancel-arbs", {
    data: { membershipid: membershipId },
  });
}

export function searchMembership(data) {
  return apiPost("/utility/search/", data);
}

export function searchByZip(data) {
  return apiPost("/utility/searchbyzip/", data);
}

export function getStripeProducts() {
  return apiGet("/utility/stripeproducts");
}

export function getCampaign(data) {
  return apiPost("/utility/campaigns/", data);
}

// boatSfid goes in the query string: the body is forwarded to a Salesforce endpoint that rejects unknown fields.
export function getAor(data, boatSfid) {
  return apiPost("/utility/aor/", data, boatSfid ? { params: { boat_sfid: boatSfid } } : {});
}

export function getAorFranchiseeLink(data) {
  return apiPost("/utility/aorfranchiseelink/", data);
}

export function getAorContactEmail(data) {
  return apiPost("/aorcontactemail/", data);
}

export function searchAccounts(keyword, limit = 30) {
  return apiGet(`/searchaccounts/${keyword}/${limit}`);
}

export function getAorContactEmailBySfid(aorSfid) {
  return apiGet(`/aorcontactemail/${aorSfid}`);
}

export function resendCard(recordId) {
  return apiPost("/utility/resendcard/", { recordId });
}
